export default __webpack_public_path__ + "static/media/circular-graph.12c97adb.png";